import { useState, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import {
  Dialog,
  DialogProps,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';

import { Button } from '../../../../../components/Button';
import { useRoute } from '../../../hooks/route';

interface IProps extends DialogProps {
  routeId: number;
  routeName: string;
  onClose: () => void;
}

export const ReleaseRoute = ({
  routeId,
  routeName,
  onClose,
  ...props
}: IProps) => {
  const { routeReleased } = useRoute();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(async () => {
    setLoading(true);

    try {
      await routeReleased(routeId).then(() => {
        enqueueSnackbar('Rota liberada com sucesso!', {
          variant: 'success',
        });

        onClose();
      });
    } catch (error) {
      console.log(error);
      enqueueSnackbar('Erro ao liberar Rota!', {
        variant: 'error',
      });
    }

    setLoading(false);
  }, [enqueueSnackbar, onClose, routeReleased, routeId]);

  return (
    <Dialog
      maxWidth="sm"
      onClose={onClose}
      aria-labelledby="releasing-dialog-title"
      aria-describedby="releasing-dialog-description"
      {...props}
    >
      <DialogTitle id="confirmation-dialog-title">
        Liberar {routeName}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">
          Deseja realmente liberar essa rota?
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="inherit" onClick={onClose}>
          Fechar
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={handleSubmit}
          loading={loading}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
